// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageViewerViewport.empty ~ .ViewportOverlay {
  display: none;
}
.ViewportOverlay {
  color: hsl(var(--highlight));
}
.ViewportOverlay .overlay-element {
  position: absolute;
  font-weight: 400;
  pointer-events: none;
}
.overlay-top {
  top: 2.15rem;
}
.overlay-bottom {
  bottom: 2.15rem;
}

/* Base text styling without shadow */
.overlay-text {
  /* No default shadow - will be applied by shadow classes */
}

/* Dark shadow for light backgrounds */
.shadow-dark {
  text-shadow: 0.8px 0.8px 0.5px rgba(0, 0, 0, 0.65);
}

/* Light shadow for dark backgrounds */
.shadow-light {
  text-shadow: 0.8px 0.8px 0.5px rgba(255, 255, 255, 0.65);
}`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/Viewport/ViewportOverlay.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,0DAA0D;AAC5D;;AAEA,sCAAsC;AACtC;EACE,kDAAkD;AACpD;;AAEA,sCAAsC;AACtC;EACE,wDAAwD;AAC1D","sourcesContent":[".imageViewerViewport.empty ~ .ViewportOverlay {\r\n  display: none;\r\n}\r\n.ViewportOverlay {\r\n  color: hsl(var(--highlight));\r\n}\r\n.ViewportOverlay .overlay-element {\r\n  position: absolute;\r\n  font-weight: 400;\r\n  pointer-events: none;\r\n}\r\n.overlay-top {\r\n  top: 2.15rem;\r\n}\r\n.overlay-bottom {\r\n  bottom: 2.15rem;\r\n}\r\n\r\n/* Base text styling without shadow */\r\n.overlay-text {\r\n  /* No default shadow - will be applied by shadow classes */\r\n}\r\n\r\n/* Dark shadow for light backgrounds */\r\n.shadow-dark {\r\n  text-shadow: 0.8px 0.8px 0.5px rgba(0, 0, 0, 0.65);\r\n}\r\n\r\n/* Light shadow for dark backgrounds */\r\n.shadow-light {\r\n  text-shadow: 0.8px 0.8px 0.5px rgba(255, 255, 255, 0.65);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
